import FinishOrder from "./FinishOrder";
import CustomerService from "./CustomerService";
import {useLocation, useSearchParams} from "react-router-dom";
import {useEffect} from "react";
import i18n from "../reducers/i18n";
import {connect} from "react-redux";
import {Typography} from "@mui/material";
export default connect(
  ({
    // to use redux states here
    i18n,
    isLoading,
    orderSubscription,
  }) => ({
    i18n,
    isLoading,
    orderSubscription,
  }),
  {
    // redux functions
  }
)((props, {}) => {
  let i18n = props.i18n;
  const location = useLocation();
  const queryParams = new URLSearchParams(window.location.search);
  const isMobile = queryParams.get("isMobile");
  // const queryParams = new URLSearchParams(location.search);
  // const isMobile = queryParams.get("isMobile");
  // const isMobile = true;
  useEffect(() => {
    if (isMobile) {
      console.log("Order subscription completed. Returning to mobile app.");
      // // Redirect to mobile app using deep link
      // window.location.href = "myapp://return"; // Replace with actual deep link
    }
  }, [isMobile]);

  return (
    <div className="step-content" style={{height: "600px"}}>
      <div className="wrapper">
        {isMobile ? (
          <Typography variant="h3">{i18n.order_finished_message}</Typography>
        ) : (
          <>
            <div className="column-left">
              <FinishOrder />
            </div>
            <div className="column-right hide-on-mobile">
              <CustomerService />
            </div>
          </>
        )}
      </div>
    </div>
  );
});
